// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"abTMf":[function(require,module,exports) {
/*----------------------------
Styles
----------------------------*/ // import '../../../styles/templates/customers/customers.scss';
// import '../../../styles/templates/customers/addresses.scss';
/*----------------------------
Customer Addresses
---
Mainly creates functionality to show the appropriate country/province selectors.
----------------------------*/ var _themeAddresses = require("@shopify/theme-addresses");
// Save the selectors
const selectors = {
    addressContainer: "[data-address]",
    addressFields: "[data-address-fields]",
    addressToggle: "[data-address-toggle]",
    addressForm: "[data-address-form]",
    addressDeleteForm: "[data-address-delete-form]"
};
const hideClass = "hide";
// Initialize Form - Helper
function initializeAddressForm(container) {
    const addressFields = container.querySelector(selectors.addressFields);
    const addressForm = container.querySelector(selectors.addressForm);
    const deleteForm = container.querySelector(selectors.addressDeleteForm);
    container.querySelectorAll(selectors.addressToggle).forEach((button)=>{
        button.addEventListener("click", (e)=>{
            e.preventDefault();
            addressForm.classList.toggle(hideClass);
        });
    });
    // Initialize - Auto populate country/province.
    (0, _themeAddresses.AddressForm)(addressFields, "en");
    // Delete Form
    if (deleteForm) deleteForm.addEventListener("submit", (event)=>{
        const confirmMessage = deleteForm.getAttribute("data-confirm-message");
        if (!window.confirm(confirmMessage || "Are you sure you wish to delete this address?")) event.preventDefault();
    });
}
/*----------------------------
Initialize Address Forms
----------------------------*/ const addressForms = document.querySelectorAll(selectors.addressContainer);
if (addressForms.length) addressForms.forEach((addressContainer)=>{
    initializeAddressForm(addressContainer);
});

},{"@shopify/theme-addresses":"4MFaP"}],"4MFaP":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddressForm", ()=>(0, _addressFormDefault.default));
var _addressForm = require("./addressForm");
var _addressFormDefault = parcelHelpers.interopDefault(_addressForm);

},{"./addressForm":"fCkEZ","@parcel/transformer-js/src/esmodule-helpers.js":"B6NKQ"}],"fCkEZ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>AddressForm);
var _loader = require("./loader");
var _helpers = require("./helpers");
var FIELD_REGEXP = /({\w+})/g;
var LINE_DELIMITER = "_";
var INPUT_SELECTORS = {
    lastName: '[name="address[last_name]"]',
    firstName: '[name="address[first_name]"]',
    company: '[name="address[company]"]',
    address1: '[name="address[address1]"]',
    address2: '[name="address[address2]"]',
    country: '[name="address[country]"]',
    zone: '[name="address[province]"]',
    postalCode: '[name="address[zip]"]',
    city: '[name="address[city]"]',
    phone: '[name="address[phone]"]'
};
function AddressForm(rootEl, locale, options) {
    locale = locale || "en";
    options = options || {
        inputSelectors: {}
    };
    var formElements = loadFormElements(rootEl, (0, _helpers.mergeObjects)(INPUT_SELECTORS, options.inputSelectors));
    validateElements(formElements);
    return loadShippingCountries(options.shippingCountriesOnly).then(function(shippingCountryCodes) {
        return (0, _loader.loadCountries)(locale).then(function(countries) {
            init(rootEl, formElements, filterCountries(countries, shippingCountryCodes));
        });
    });
}
/**
 * Runs when countries have been loaded
 */ function init(rootEl, formElements, countries) {
    populateCountries(formElements, countries);
    var selectedCountry = formElements.country.input ? formElements.country.input.value : null;
    setEventListeners(rootEl, formElements, countries);
    handleCountryChange(rootEl, formElements, selectedCountry, countries);
}
/**
 * Handles when a country change: set labels, reorder fields, populate zones
 */ function handleCountryChange(rootEl, formElements, countryCode, countries) {
    var country = getCountry(countryCode, countries);
    setLabels(formElements, country);
    reorderFields(rootEl, formElements, country);
    populateZones(formElements, country);
}
/**
 * Sets up event listener for country change
 */ function setEventListeners(rootEl, formElements, countries) {
    formElements.country.input.addEventListener("change", function(event) {
        handleCountryChange(rootEl, formElements, event.target.value, countries);
    });
}
/**
 * Reorder fields in the DOM and add data-attribute to fields given a country
 */ function reorderFields(rootEl, formElements, country) {
    var formFormat = country.formatting.edit;
    var countryWrapper = formElements.country.wrapper;
    var afterCountry = false;
    getOrderedField(formFormat).forEach(function(row) {
        row.forEach(function(line) {
            formElements[line].wrapper.dataset.lineCount = row.length;
            if (!formElements[line].wrapper) return;
            if (line === "country") {
                afterCountry = true;
                return;
            }
            if (afterCountry) rootEl.append(formElements[line].wrapper);
            else rootEl.insertBefore(formElements[line].wrapper, countryWrapper);
        });
    });
}
/**
 * Update labels for a given country
 */ function setLabels(formElements, country) {
    Object.keys(formElements).forEach(function(formElementName) {
        formElements[formElementName].labels.forEach(function(label) {
            label.textContent = country.labels[formElementName];
        });
    });
}
/**
 * Add right countries in the dropdown for a given country
 */ function populateCountries(formElements, countries) {
    var countrySelect = formElements.country.input;
    var duplicatedCountrySelect = countrySelect.cloneNode(true);
    countries.forEach(function(country) {
        var optionElement = document.createElement("option");
        optionElement.value = country.code;
        optionElement.textContent = country.name;
        duplicatedCountrySelect.appendChild(optionElement);
    });
    countrySelect.innerHTML = duplicatedCountrySelect.innerHTML;
    if (countrySelect.dataset.default) countrySelect.value = countrySelect.dataset.default;
}
/**
 * Add right zones in the dropdown for a given country
 */ function populateZones(formElements, country) {
    var zoneEl = formElements.zone;
    if (!zoneEl) return;
    if (country.zones.length === 0) {
        zoneEl.wrapper.dataset.ariaHidden = "true";
        zoneEl.input.innerHTML = "";
        return;
    }
    zoneEl.wrapper.dataset.ariaHidden = "false";
    var zoneSelect = zoneEl.input;
    var duplicatedZoneSelect = zoneSelect.cloneNode(true);
    duplicatedZoneSelect.innerHTML = "";
    country.zones.forEach(function(zone) {
        var optionElement = document.createElement("option");
        optionElement.value = zone.code;
        optionElement.textContent = zone.name;
        duplicatedZoneSelect.appendChild(optionElement);
    });
    zoneSelect.innerHTML = duplicatedZoneSelect.innerHTML;
    if (zoneSelect.dataset.default) zoneSelect.value = zoneSelect.dataset.default;
}
/**
 * Will throw if an input or a label is missing from the wrapper
 */ function validateElements(formElements) {
    Object.keys(formElements).forEach(function(elementKey) {
        var element = formElements[elementKey].input;
        var labels = formElements[elementKey].labels;
        if (!element) return;
        if (typeof element !== "object") throw new TypeError(formElements[elementKey] + " is missing an input or select.");
        else if (typeof labels !== "object") throw new TypeError(formElements[elementKey] + " is missing a label.");
    });
}
/**
 * Given an countryCode (eg. 'CA'), will return the data of that country
 */ function getCountry(countryCode, countries) {
    countryCode = countryCode || "CA";
    return countries.filter(function(country) {
        return country.code === countryCode;
    })[0];
}
/**
 * Given a format (eg. "{firstName}{lastName}_{company}_{address1}_{address2}_{city}_{country}{province}{zip}_{phone}")
 * will return an array of how the form needs to be formatted, eg.:
 * =>
 * [
 *   ['firstName', 'lastName'],
 *   ['company'],
 *   ['address1'],
 *   ['address2'],
 *   ['city'],
 *   ['country', 'province', 'zip'],
 *   ['phone']
 * ]
 */ function getOrderedField(format) {
    return format.split(LINE_DELIMITER).map(function(fields) {
        var result = fields.match(FIELD_REGEXP);
        if (!result) return [];
        return result.map(function(fieldName) {
            var newFieldName = fieldName.replace(/[{}]/g, "");
            switch(newFieldName){
                case "zip":
                    return "postalCode";
                case "province":
                    return "zone";
                default:
                    return newFieldName;
            }
        });
    });
}
/**
 * Given a rootEl where all `input`s, `select`s, and `labels` are nested, it
 * will returns all form elements (wrapper, input and labels) of the form.
 * See `FormElements` type for details
 */ function loadFormElements(rootEl, inputSelectors) {
    var elements = {};
    Object.keys(INPUT_SELECTORS).forEach(function(inputKey) {
        var input = rootEl.querySelector(inputSelectors[inputKey]);
        elements[inputKey] = input ? {
            wrapper: input.parentElement,
            input: input,
            labels: document.querySelectorAll('[for="' + input.id + '"]')
        } : {};
    });
    return elements;
}
/**
 * If shippingCountriesOnly is set to true, will return the list of countries the
 * shop ships to. Otherwise returns null.
 */ function loadShippingCountries(shippingCountriesOnly) {
    if (!shippingCountriesOnly) // eslint-disable-next-line no-undef
    return Promise.resolve(null);
    var response = fetch(location.origin + "/meta.json");
    return response.then(function(res) {
        return res.json();
    }).then(function(meta) {
        // If ships_to_countries has * in the list, it means the shop ships to
        // all countries
        return meta.ships_to_countries.indexOf("*") !== -1 ? null : meta.ships_to_countries;
    }).catch(function() {
        return null;
    });
}
/**
 * Only returns countries that are in includedCountryCodes
 * Returns all countries if no includedCountryCodes is passed
 */ function filterCountries(countries, includedCountryCodes) {
    if (!includedCountryCodes) return countries;
    return countries.filter(function(country) {
        return includedCountryCodes.indexOf(country.code) !== -1;
    });
}

},{"./loader":"jode9","./helpers":"1lwvF","@parcel/transformer-js/src/esmodule-helpers.js":"B6NKQ"}],"jode9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadCountries", ()=>loadCountries);
parcelHelpers.export(exports, "SUPPORTED_LOCALES", ()=>SUPPORTED_LOCALES);
parcelHelpers.export(exports, "toSupportedLocale", ()=>toSupportedLocale);
var query = "query countries($locale: SupportedLocale!) {  countries(locale: $locale) {    name    code    labels {      address1      address2      city      company      country      firstName      lastName      phone      postalCode      zone    }    formatting {      edit    }    zones {      name      code    }  }}";
var GRAPHQL_ENDPOINT = "https://country-service.shopifycloud.com/graphql";
function loadCountries(locale) {
    var response = fetch(GRAPHQL_ENDPOINT, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
            query: query,
            operationName: "countries",
            variables: {
                locale: toSupportedLocale(locale)
            }
        })
    });
    return response.then(function(res) {
        return res.json();
    }).then(function(countries) {
        return countries.data.countries;
    });
}
var DEFAULT_LOCALE = "EN";
var SUPPORTED_LOCALES = [
    "DA",
    "DE",
    "EN",
    "ES",
    "FR",
    "IT",
    "JA",
    "NL",
    "PT",
    "PT_BR"
];
function toSupportedLocale(locale) {
    var supportedLocale = locale.replace(/-/, "_").toUpperCase();
    if (SUPPORTED_LOCALES.indexOf(supportedLocale) !== -1) return supportedLocale;
    else if (SUPPORTED_LOCALES.indexOf(supportedLocale.substring(0, 2)) !== -1) return supportedLocale.substring(0, 2);
    else return DEFAULT_LOCALE;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"B6NKQ"}],"B6NKQ":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"1lwvF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeObjects", ()=>mergeObjects);
function mergeObjects() {
    var to = Object({});
    for(var index = 0; index < arguments.length; index++){
        var nextSource = arguments[index];
        if (nextSource) {
            for(var nextKey in nextSource)if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"B6NKQ"}]},["abTMf"], "abTMf", "parcelRequire83e8")

//# sourceMappingURL=template.addresses.js.map
